// 手机号码验证 简单验证
export const mobileExp = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;

// 手机号码验证 严格验证
export const strictMobileExp = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/